import { render, staticRenderFns } from "./SingleImgPred.vue?vue&type=template&id=04efc65a&scoped=true&"
import script from "./SingleImgPred.vue?vue&type=script&lang=js&"
export * from "./SingleImgPred.vue?vue&type=script&lang=js&"
import style0 from "./SingleImgPred.vue?vue&type=style&index=0&id=04efc65a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04efc65a",
  null
  
)

component.options.__file = "SingleImgPred.vue"
export default component.exports